import { DatePipe } from "@angular/common";
import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { tap, catchError } from "rxjs/operators";
import { BaseService } from "../base.service";
import { ChangePasswordDTO } from "../../models/auth/change-password-dto.model";
import { environment } from "src/environments/environment";

@Injectable()
export class UserService extends BaseService<any>{
    constructor(public httpClient: HttpClient, public datepipe: DatePipe) {
        super(
            'auth',
            httpClient);
    }

    changePassword(changePasswordDto: ChangePasswordDTO): Observable<Boolean> {
        let uri = new URL(environment.baseUrl + `/auth/changePassword`);
        return this.httpClient.post<Boolean>(uri.toString(), changePasswordDto, { withCredentials: false, headers: this.httpHeaders() })
            .pipe(
                tap(),
                catchError(this.handleError)
            )
    }

    getCompany() {
        if(!localStorage.getItem('user')) return;
        return JSON.parse(localStorage.getItem('user'))["company"] || null;
    }
    //TODO: impersonation !!!
}
